import styled from 'styled-components';
import { Button } from 'antd';

export const FlowContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  height: 75px;
  border: 1px solid rgb(0 0 0 / 6%);
  border-radius: 4px;
  background-color: #fff;
  overflow: auto hidden;

  /* Add scrollbar styling */
  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  @media (max-width: 1200px) {
    overflow-x: auto;
  }
`;

export const GaugeSection = styled.div`
  width: 480px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 0 10px;
  border-right: 1px solid rgb(0 0 0 / 6%);

  @media (max-width: 1200px) {
    min-width: 480px;
  }
`;

export const ChartSection = styled.div`
  width: 575px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 10px;
  border-right: 1px solid rgb(0 0 0 / 6%);

  @media (max-width: 1200px) {
    min-width: 575px;
  }
`;

export const MetadataSection = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  padding: 10px;
  min-width: 380px;
  overflow: hidden;
  position: relative;

  > *:last-child {
    flex-shrink: 0;
    margin-left: auto;
    margin-right: 0;
  }

  @media (max-width: 1200px) {
    min-width: 380px;
  }
`;

export const StyledCloseBtn = styled(Button)`
  right: -7px;
  top: -22px;
`;
